import {
  Row,
  Col,
  Typography,
  Input,
  Button,
  Modal,
} from "antd";
import React, { useState } from "react";
import { Label } from "aws-amplify-react";
import TextArea from "antd/lib/input/TextArea";

const SendTestEmailModal = ({
    subject = "Test Sending Email",
    body = "This is a test email from the BluStream email system",
    recipients = [],
    onSendClick=() => {},
    onCancelClick=() => {}
}) => {
    const [testEmailSubject, setTestEmailSubject] = useState(subject)
    const [testEmailBody, setTestEmailBody] = useState(body)
    const [testEmailRecipients, setTestEmailRecipients] = useState(recipients)


    return (
        <Modal
        className="send-test-email-modal"
        open={true}
        closable={false}
        footer={[
            <Button
                className="standard-button secondary-orange-button"
                key="confirm"
                onClick={() => { onSendClick(testEmailSubject, testEmailBody, testEmailRecipients) }}>Send</Button>,
            <Button
                className="standard-button primary-orange-button"
                key="stay"
                type="primary"
                onClick={() => { onCancelClick(); }}>Cancel</Button>
            ]}>
        <Row>
            <Col span={24}>
                <Typography.Title level={5}>
                Test Your Email Configuration
                </Typography.Title>
            
                <Label>Subject:
                <Input
                    id={"subject"}
                    value={testEmailSubject}
                    onChange={(event) => { event.preventDefault(); setTestEmailSubject(event.target.value) }}
                ></Input>
                </Label>
                <Label>Recipients:
                <Input
                    id={"recipients"}
                    value={testEmailRecipients}
                    onChange={(event) => { event.preventDefault(); setTestEmailRecipients(event.target.value) }}
                ></Input>
                </Label>
                <Label>Body:
                    <TextArea
                    id={"body"}
                    value={testEmailBody}
                    onChange={(event) => { event.preventDefault(); setTestEmailBody(event.target.value)}}
                    ></TextArea>
                </Label>
            </Col>
            </Row>
        </Modal>
    );
};
export default SendTestEmailModal;